import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef4aafa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1))
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_22 = {
  key: 0,
  lass: "ant-row"
}
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_36 = { class: "ant-row" }
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_40 = {
  key: 0,
  class: "ui-card ui-mt-30"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Informações da Integração")
      ])
    ])
  ])
], -1))
const _hoisted_42 = { class: "ui-card-body" }
const _hoisted_43 = { class: "ant-row" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_47 = {
  key: 1,
  class: "ui-card ui-mt-30"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Informações da Integração")
      ])
    ])
  ])
], -1))
const _hoisted_49 = { class: "ui-card-body" }
const _hoisted_50 = { class: "ant-row" }
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_53 = { class: "ui-card ui-mt-30" }
const _hoisted_54 = { class: "ui-card-header" }
const _hoisted_55 = { class: "ui-card-header-content" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Áreas de Entrega")
  ])
], -1))
const _hoisted_57 = { class: "ui-card-header-content-button" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Nova área")
], -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "ui-button-content" }
const _hoisted_61 = { class: "ui-card-body" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "ui-button ui-mh-32 ui-full",
  type: "button",
  "ant-click-animating-without-extra-node": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Clique aqui para selecionar o arquivo")
], -1))
const _hoisted_63 = { class: "ant-row" }
const _hoisted_64 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Iniciar importação", -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { class: "ui-table" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-5 ui-cell ui-cell-editable" }, " Região/Estado/Cidade "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable" }, " CEP Inicial "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable" }, " CEP Final "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable" }, " Peso Mínimo KG "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable" }, " Peso Máximo KG "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable" }, " Prazo Entrega "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable" }, " Valor R$ "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable ui-align-center" })
], -1))
const _hoisted_70 = { class: "ui-rows" }
const _hoisted_71 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-5 ui-cell ui-cell-editable",
  "data-title": "Região/Estado/Cidade"
}
const _hoisted_72 = ["onChange", "onUpdate:modelValue"]
const _hoisted_73 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable",
  "data-title": "CEP Inicial"
}
const _hoisted_74 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable",
  "data-title": "CEP Final"
}
const _hoisted_75 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable",
  "data-title": "Peso Mínimo KG"
}
const _hoisted_76 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable",
  "data-title": "Peso Máximo KG"
}
const _hoisted_77 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable",
  "data-title": "Prazo Entrega"
}
const _hoisted_78 = ["on:valorDigitado", "onUpdate:modelValue"]
const _hoisted_79 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable",
  "data-title": "Valor Frete"
}
const _hoisted_80 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "Ações"
}
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "ui-button-content" }
const _hoisted_83 = {
  key: 1,
  style: {"overflow-x":"auto","overflow-y":"auto","max-height":"600px"}
}
const _hoisted_84 = { class: "ui-table ui-scroll-area" }
const _hoisted_85 = { class: "ant-row ui-row header" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable" }, " Região/Estado/Cidade ", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable" }, " CEP Inicial ", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable" }, " CEP Final ", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable" }, " Peso Mínimo KG ", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable" }, " Peso Máximo KG ", -1))
const _hoisted_91 = { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable" }, " Valor R$ ", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable" }, " % Frete ", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable" }, " Limite KG Adicional ", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable" }, " Valor KG Adicional ", -1))
const _hoisted_96 = { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable" }
const _hoisted_97 = { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable" }
const _hoisted_98 = { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable" }
const _hoisted_99 = { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable" }
const _hoisted_100 = { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable ui-align-center" }, null, -1))
const _hoisted_102 = { class: "ui-rows" }
const _hoisted_103 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-cell-editable",
  "data-title": "Região/Estado/Cidade"
}
const _hoisted_104 = ["onChange", "onUpdate:modelValue"]
const _hoisted_105 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable",
  "data-title": "CEP Inicial"
}
const _hoisted_106 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable",
  "data-title": "CEP Final"
}
const _hoisted_107 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable",
  "data-title": "Peso Mínimo KG"
}
const _hoisted_108 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable",
  "data-title": "Peso Máximo KG"
}
const _hoisted_109 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "Prazo Entrega"
}
const _hoisted_110 = ["on:valorDigitado", "onUpdate:modelValue"]
const _hoisted_111 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "Valor Frete"
}
const _hoisted_112 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "% Frete"
}
const _hoisted_113 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable",
  "data-title": "Limite KG Adicional"
}
const _hoisted_114 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-cell-editable",
  "data-title": "Valor KG Adicional"
}
const _hoisted_115 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "Taxa Despacho"
}
const _hoisted_116 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "Taxa Difícil Acesso"
}
const _hoisted_117 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "Taxa Entrega Rural"
}
const _hoisted_118 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "% Taxa Dificuldade Entrega"
}
const _hoisted_119 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "% Taxa Restrição Tráfego"
}
const _hoisted_120 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "Ações"
}
const _hoisted_121 = ["onClick"]
const _hoisted_122 = { class: "ui-button-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_caixa_selecao = _resolveComponent("caixa-selecao")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Tipo")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_caixa_selecao, {
                      opcoes: _ctx.state.opcoesCaixaSelacao,
                      valor: _ctx.state.formaEntrega.tipo,
                      "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.formaEntrega.tipo) = $event))
                    }, null, 8, ["opcoes", "valor"])
                  ])
                ]),
                _createVNode(_component_a_divider),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Nome" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.formaEntrega.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.formaEntrega.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.formaEntrega.status,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.formaEntrega.status) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Inativa")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ativa")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, { label: "Código Serviço" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.formaEntrega.codigoServico) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.formaEntrega.codigoServico]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, { label: "Código Tabela" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.formaEntrega.codigoTabela) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.formaEntrega.codigoTabela]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, { label: "Código ERP" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.formaEntrega.codigoErp) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.formaEntrega.codigoErp]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                ((_ctx.state.formaEntrega.tipo !== _ctx.ETipoFormaEntrega.FRENET))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_a_form_item, { label: "Conceito do Valor do Frete" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _ctx.state.formaEntrega.conceitoValorFrete,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.formaEntrega.conceitoValorFrete) = $event)),
                              "button-style": "solid"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Valor Fixo")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Fórmula Personalizada")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.formaEntrega.conceitoValorFrete === _ctx.EConceitoValorFrete.FormulaPersonalizada)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_a_form_item, { label: "Fator Cubagem" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 3,
                                valor: _ctx.state.formaEntrega.fatorCubagem,
                                "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.formaEntrega.fatorCubagem) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_a_form_item, { label: "Gerenciamento Risco" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                percentual: true,
                                valor: _ctx.state.formaEntrega.percentualGerenciamentoRisco,
                                "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.formaEntrega.percentualGerenciamentoRisco) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_a_form_item, { label: "Valor Mín. Gerenciamento Risco" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.state.formaEntrega.valorMinimoGerenciamentoRisco,
                                "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.formaEntrega.valorMinimoGerenciamentoRisco) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_a_form_item, { label: "Seguro" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                percentual: true,
                                valor: _ctx.state.formaEntrega.percentualSeguro,
                                "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.formaEntrega.percentualSeguro) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_a_form_item, { label: "Impostos" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                percentual: true,
                                valor: _ctx.state.formaEntrega.percentualImpostos,
                                "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.formaEntrega.percentualImpostos) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_a_form_item, { label: "Taxa Administração SEFAZ" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.state.formaEntrega.taxaAdministracaoSefaz,
                                "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.formaEntrega.taxaAdministracaoSefaz) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_a_form_item, { label: "Valor Pedágio" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.state.formaEntrega.valorPedagio,
                                "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.formaEntrega.valorPedagio) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_a_form_item, { label: "Cobrar Pedágio a Cada X KG" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 3,
                                valor: _ctx.state.formaEntrega.cobrarPedagioACadaXKg,
                                "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.formaEntrega.cobrarPedagioACadaXKg) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_a_form_item, { label: "Valor Mín. Dificuldade Entrega" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.state.formaEntrega.valorMinimoTaxaDificuldadeEntrega,
                                "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.formaEntrega.valorMinimoTaxaDificuldadeEntrega) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_a_form_item, { label: "Valor Mín. Restrição Tráfego" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.state.formaEntrega.valorMinimoTaxaRestricaoTrafego,
                                "onUpdate:valor": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.formaEntrega.valorMinimoTaxaRestricaoTrafego) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_a_form_item, { label: "Fórmula para Cálcular o Frete" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_textarea, {
                                value: _ctx.state.formaEntrega.formula,
                                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.formaEntrega.formula) = $event)),
                                placeholder: "Digite as variavéis para calcular",
                                "allow-clear": "",
                                rows: 4
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Instruções")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.formaEntrega.instrucoes,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.formaEntrega.instrucoes) = $event))
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]),
            ((_ctx.state.formaEntrega.tipo === _ctx.ETipoFormaEntrega.FRENET))
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_a_form_item, { label: "Token" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.formaEntrega.tokenIntegracao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.formaEntrega.tokenIntegracao]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_a_form_item, { label: "Usuário" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.formaEntrega.usuarioIntegracao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.formaEntrega.usuarioIntegracao]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_a_form_item, { label: "Senha" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "password",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.formaEntrega.senhaIntegracao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.formaEntrega.senhaIntegracao]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            ((_ctx.state.formaEntrega.tipo === _ctx.ETipoFormaEntrega.Correios))
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_a_form_item, { label: "Usuário/Chave" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.formaEntrega.usuarioIntegracao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.formaEntrega.usuarioIntegracao]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_a_form_item, { label: "Cartão Postagem" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.formaEntrega.senhaIntegracao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.formaEntrega.senhaIntegracao]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("button", {
                      class: "ui-button -primary ui-mh-32",
                      type: "button",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.novaAreaEntrega()))
                    }, _hoisted_59),
                    ((_ctx.state.formaEntrega.codigo > 0))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "ui-button ui-mh-32",
                          type: "button",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.state.apresentarImportacaoTabela = !_ctx.state.apresentarImportacaoTabela))
                        }, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.state.apresentarImportacaoTabela?'Voltar para lançamento manual':'Importar Tabela'), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_a_upload, {
                    class: "ui-full",
                    "file-list": _ctx.state.listaArquivos,
                    "onUpdate:fileList": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.listaArquivos) = $event)),
                    multiple: false,
                    "before-upload": _ctx.prepararArquivoUpload,
                    onRemove: _ctx.removerArquivo
                  }, {
                    default: _withCtx(() => [
                      _hoisted_62
                    ]),
                    _: 1
                  }, 8, ["file-list", "before-upload", "onRemove"]),
                  _withDirectives(_createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ui-button -primary ui-mh-32 ui-full",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.importarArquivo()))
                      }, _hoisted_66)
                    ])
                  ], 512), [
                    [_vShow, (_ctx.state.listaArquivos.length > 0)]
                  ])
                ], 512), [
                  [_vShow, _ctx.state.apresentarImportacaoTabela]
                ]),
                (_ctx.state.formaEntrega.conceitoValorFrete === _ctx.EConceitoValorFrete.ValorFixo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _withDirectives(_createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("div", _hoisted_70, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.formaEntrega.areas, (area, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: _normalizeClass(area.removida?'ui-d-none':'ant-row ui-row ui-row-editable')
                            }, [
                              _createElementVNode("div", _hoisted_71, [
                                _withDirectives(_createElementVNode("input", {
                                  onChange: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": ($event: any) => ((area.regiaoEstadoCidade) = $event)
                                }, null, 40, _hoisted_72), [
                                  [_vModelText, area.regiaoEstadoCidade]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _createVNode(_component_campo_cep, {
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.cepInicial,
                                  "onUpdate:valor": ($event: any) => ((area.cepInicial) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_74, [
                                _createVNode(_component_campo_cep, {
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.cepFinal,
                                  "onUpdate:valor": ($event: any) => ((area.cepFinal) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _createVNode(_component_campo_numerico, {
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  quantidadeCasasDecimais: 3,
                                  valor: area.pesoMinimo,
                                  "onUpdate:valor": ($event: any) => ((area.pesoMinimo) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_76, [
                                _createVNode(_component_campo_numerico, {
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  quantidadeCasasDecimais: 3,
                                  valor: area.pesoMaximo,
                                  "onUpdate:valor": ($event: any) => ((area.pesoMaximo) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_77, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "on:valorDigitado": ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  class: "ant-input",
                                  "onUpdate:modelValue": ($event: any) => ((area.prazoEntrega) = $event)
                                }, null, 40, _hoisted_78), [
                                  [_vModelText, area.prazoEntrega]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_79, [
                                _createVNode(_component_campo_numerico, {
                                  class: "ui-full",
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.valorFrete,
                                  "onUpdate:valor": ($event: any) => ((area.valorFrete) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("button", {
                                  class: "ui-button ui-mh-32 ui-full",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.removerAreaEntrega(index))
                                }, [
                                  _createElementVNode("div", _hoisted_82, [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ])
                                  ])
                                ], 8, _hoisted_81)
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ], 512), [
                        [_vShow, (_ctx.state.formaEntrega.areas.length > 0 && !_ctx.state.apresentarImportacaoTabela)]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.formaEntrega.conceitoValorFrete === _ctx.EConceitoValorFrete.FormulaPersonalizada)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _withDirectives(_createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _hoisted_86,
                          _hoisted_87,
                          _hoisted_88,
                          _hoisted_89,
                          _hoisted_90,
                          _createElementVNode("div", _hoisted_91, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Prazo Entrega"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" P.Entrega ")
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_92,
                          _hoisted_93,
                          _hoisted_94,
                          _hoisted_95,
                          _createElementVNode("div", _hoisted_96, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Taxa Despacho"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" T.Despacho ")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Taxa Difícil Acesso"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" TDA ")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_98, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Taxa Entrega Rural"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" TER ")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_99, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "% Taxa Dificuldade Entrega"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" % TDE ")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_100, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "% Taxa Restrição Tráfego"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" % TRF ")
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_101
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.formaEntrega.areas, (area, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: _normalizeClass(area.removida?'ui-d-none':'ant-row ui-row ui-row-editable')
                            }, [
                              _createElementVNode("div", _hoisted_103, [
                                _withDirectives(_createElementVNode("input", {
                                  onChange: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": ($event: any) => ((area.regiaoEstadoCidade) = $event)
                                }, null, 40, _hoisted_104), [
                                  [_vModelText, area.regiaoEstadoCidade]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_105, [
                                _createVNode(_component_campo_cep, {
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.cepInicial,
                                  "onUpdate:valor": ($event: any) => ((area.cepInicial) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_106, [
                                _createVNode(_component_campo_cep, {
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.cepFinal,
                                  "onUpdate:valor": ($event: any) => ((area.cepFinal) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_107, [
                                _createVNode(_component_campo_numerico, {
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  quantidadeCasasDecimais: 3,
                                  valor: area.pesoMinimo,
                                  "onUpdate:valor": ($event: any) => ((area.pesoMinimo) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_108, [
                                _createVNode(_component_campo_numerico, {
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  quantidadeCasasDecimais: 3,
                                  valor: area.pesoMaximo,
                                  "onUpdate:valor": ($event: any) => ((area.pesoMaximo) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_109, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "on:valorDigitado": ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  class: "ant-input",
                                  "onUpdate:modelValue": ($event: any) => ((area.prazoEntrega) = $event)
                                }, null, 40, _hoisted_110), [
                                  [_vModelText, area.prazoEntrega]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_111, [
                                _createVNode(_component_campo_numerico, {
                                  class: "ui-full",
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.valorFrete,
                                  "onUpdate:valor": ($event: any) => ((area.valorFrete) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_112, [
                                _createVNode(_component_campo_numerico, {
                                  class: "ui-full",
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.percentualFrete,
                                  "onUpdate:valor": ($event: any) => ((area.percentualFrete) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_113, [
                                _createVNode(_component_campo_numerico, {
                                  class: "ui-full",
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.limiteKgAdicional,
                                  "onUpdate:valor": ($event: any) => ((area.limiteKgAdicional) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_114, [
                                _createVNode(_component_campo_numerico, {
                                  class: "ui-full",
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.valorKgAdicional,
                                  "onUpdate:valor": ($event: any) => ((area.valorKgAdicional) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_115, [
                                _createVNode(_component_campo_numerico, {
                                  class: "ui-full",
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.taxaDespacho,
                                  "onUpdate:valor": ($event: any) => ((area.taxaDespacho) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_116, [
                                _createVNode(_component_campo_numerico, {
                                  class: "ui-full",
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.taxaDificilAcesso,
                                  "onUpdate:valor": ($event: any) => ((area.taxaDificilAcesso) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_117, [
                                _createVNode(_component_campo_numerico, {
                                  class: "ui-full",
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.taxaEntregaRural,
                                  "onUpdate:valor": ($event: any) => ((area.taxaEntregaRural) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_118, [
                                _createVNode(_component_campo_numerico, {
                                  class: "ui-full",
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.percentualTaxaDificuldadeEntrega,
                                  "onUpdate:valor": ($event: any) => ((area.percentualTaxaDificuldadeEntrega) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_119, [
                                _createVNode(_component_campo_numerico, {
                                  class: "ui-full",
                                  onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                                  valor: area.percentualTaxaRestricaoTrafego,
                                  "onUpdate:valor": ($event: any) => ((area.percentualTaxaRestricaoTrafego) = $event)
                                }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                              ]),
                              _createElementVNode("div", _hoisted_120, [
                                _createElementVNode("button", {
                                  class: "ui-button ui-mh-32 ui-full",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.removerAreaEntrega(index))
                                }, [
                                  _createElementVNode("div", _hoisted_122, [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ])
                                  ])
                                ], 8, _hoisted_121)
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ], 512), [
                        [_vShow, (_ctx.state.formaEntrega.areas.length > 0 && !_ctx.state.apresentarImportacaoTabela)]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, (_ctx.state.formaEntrega.tipo === _ctx.ETipoFormaEntrega.RetiradaLocal || _ctx.state.formaEntrega.tipo === _ctx.ETipoFormaEntrega.EntregaPropria || _ctx.state.formaEntrega.tipo === _ctx.ETipoFormaEntrega.Transportadora)]
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}